export const content = {
  'map-latitude': {
    label: 'Map latitude',
    type: 'text',
    rules: ['required']
  },
  'map-longitude': {
    label: 'Map longitude',
    type: 'text',
    rules: ['required']
  },
  'map-zoom': {
    label: 'Map zoom',
    type: 'slider',
    min: 1,
    max: 25,
    suffix: '',
    default: '15'
  }
}

export const design = {}

export const layout = {
  'map-height': {
    label: 'Map height',
    type: 'slider',
    min: 300,
    max: 600,
    step: 10,
    suffix: '',
    default: '450'
  }
}

export const advanced = {}

export default {
  content,
  design,
  layout,
  advanced
}
